<template>
  <div>
    <section class="s-abrir-conta">
      <div class="container-new">
        <RegistrationScreenBanner></RegistrationScreenBanner>
        <RegistrationScreenForm
          v-on:newAccount="createNewAccountInRepository"
        ></RegistrationScreenForm>
      </div>
    </section>
    <FooterNewLogin></FooterNewLogin>
  </div>
</template>

<style lang="scss" scoped>
$verde: #41d3bd;
$azul: #21247f;
$azul-sec: #3b46c4;
$branco: #ffffff;
$cinza-claro: #e9eafa;
$cinza-medio: #818495;
$cinza-escuro: #2c3236;

.header-login {
  display: none;

  @media (max-width: 1050px) {
    display: flex;
  }
}

.txt {
  // font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: 1.125rem; //18
  line-height: 135%;
  letter-spacing: 0.005em;
  color: $cinza-escuro;
  margin-bottom: 0;

  @media (max-width: 560px) {
    font-size: 0.875rem; //14
  }
}

header {
  z-index: 2000;
  height: 90px;
  width: 100%;
  position: fixed;
  display: flex;
  background-color: $branco;
  box-shadow: 0 0 30px -11px rgba(0, 0, 0, 0.1);

  .container-new {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .logo {
    z-index: 2;
  }

  .nav {
    display: flex;
    align-items: center;
    ul {
      margin-right: 69px;
      display: flex;
      li {
        margin-right: 48px;
        &:last-child {
          margin-right: 0;
        }
        a {
          font-weight: normal;
          font-size: 0.9375rem; //15
          line-height: 150%;
          letter-spacing: 0.01em;
          color: #3b46c4;
          transition: all 0.3s;
          &.active {
            font-weight: bold;
          }
          &:hover {
            transition: all 0.3s;
            color: $azul;
          }
        }
      }
    }
  }

  .acesso {
    margin-right: 0;
    display: flex;
    align-items: center;
    transition: all 0.3s;
    li {
      a {
        display: flex;
        align-items: center;
        .icon {
          margin-right: 12px;
          background: url(../assets/images/icon-login-green.svg) no-repeat;
          background-size: contain;
          width: 17px;
          height: 18px;
          transition: all 0.3s;
        }
        span {
          font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
          font-weight: bold;
          font-size: 1rem;
          line-height: 150%;
          letter-spacing: 0.02em;
          color: $verde;
          transition: all 0.3s;
        }
        &:hover {
          .icon {
            transition: all 0.3s;
            background: url(../assets/images/icon-login-blue.svg) no-repeat;
          }
          span {
            transition: all 0.3s;
            color: $azul;
          }
        }
      }
      &:last-child {
        margin-right: 0;
        a {
          width: 151px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: $cinza-claro;
          border-radius: 8px;
          transition: all 0.3s;
          span {
            color: $azul;
          }
          &:hover {
            transition: all 0.3s;
            background: $verde;
          }
        }
      }
    }
  }

  .menu-mobile {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding-bottom: 100px;
    background-color: $branco;
    padding-top: 120px;
    opacity: 0;
    pointer-events: none;
    transform: translateY(100%);
    overflow-y: auto;
    transition: all 0.3s;
    nav {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      ul {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;

        li {
          margin-bottom: 38px;
          a {
            font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
            font-weight: 500;
            line-height: 135%;
            font-size: 1.125rem;
            letter-spacing: 0.005em;
            color: $azul-sec;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
        &:first-child {
          margin-bottom: 100px;
        }
      }

      .acesso {
        li {
          &:last-child {
            a {
              width: 253px;
            }
          }
        }
      }
    }
  }
}

.menu-button {
  position: relative;
  z-index: 1500;
  display: none;
  width: 32px;
  padding: 8px 0;
  cursor: pointer;
  transition: 0.2s all cubic-bezier(0.4, -0.1, 0, 1.1);
  @media (max-width: 1199px) {
    display: block;
  }
}
a.menu-button:hover .menu-icon,
a.menu-button:hover .menu-icon::after {
  width: 32px;
  transition: 0.2s all cubic-bezier(0.4, -0.1, 0, 1.1);
}
.menu-icon {
  width: 32px;
  height: 5px;
  background: linear-gradient(38.88deg, #3b46c4 -0.99%, #4f5ad8 116%);
  display: block;
  position: relative;
  transition: 0.2s all cubic-bezier(0.4, -0.1, 0, 1.1);
  border-radius: 8px;
}
.menu-icon::before,
.menu-icon::after {
  content: "";
  display: block;
  height: 5px;
  border-radius: 8px;
  background: linear-gradient(38.88deg, #3b46c4 -0.99%, #4f5ad8 116%);
  position: absolute;
  right: 0;
  transition: 0.2s all cubic-bezier(0.4, -0.1, 0, 1.1);
}
.menu-icon::before {
  margin-top: -10px;
  width: 32px;
  transition: 0.2s all cubic-bezier(0.4, -0.1, 0, 1.1);
}
.menu-icon::after {
  margin-top: 10px;
  width: 32px;
  transition: 0.2s all cubic-bezier(0.4, -0.1, 0, 1.1);
}
.menu-opened .menu-icon {
  height: 0;
  width: 32px;
  transition: 0.2s all cubic-bezier(0.4, -0.1, 0, 1.1);
}
.menu-opened .menu-icon::after {
  width: 32px;
  transform: rotate(45deg);
  margin-top: 0;
  transition: 0.2s all cubic-bezier(0.4, -0.1, 0, 1.1);
}
.menu-opened .menu-icon::before {
  transform: rotate(-45deg);
  margin-top: 0;
  transition: 0.2s all cubic-bezier(0.4, -0.1, 0, 1.1);
}

.menu-opened {
  overflow: hidden;
  header {
    box-shadow: none;
    width: 100%;

    .menu-mobile {
      opacity: 1;
      pointer-events: all;
      transform: translateY(0%);
      transition: all 0.3s;
    }
  }
}

.header-login {
  display: none;

  @media (max-width: 1050px) {
    display: flex;
  }
}

.container-new {
  width: 1243px;
  padding: 0 15px;
  margin: 0 auto;
  @media (max-width: 1200px) {
    width: 100%;
    padding: 0px 24px;
  }
}

@import "../assets/styles/iouu/_variables";
@import "../assets/styles/iouu/_mixins";
.s-abrir-conta {
  padding-top: 65px;
  padding-bottom: 115px;
  border-bottom: 2px solid #81849533;

  .container-new {
    display: flex;
    justify-content: space-between;
    position: relative;
  }

  @media (max-width: 1050px) {
    padding-top: 70px;
    border-bottom: none;
    .container-new {
      justify-content: center;
      align-items: center;
      width: 100%;
    }

    .logo {
      display: none;
    }
  }

  @media (max-width: 560px) {
    padding-bottom: 50px !important;
  }
}
/****** FOOTER ******/

@media (max-width: 1050px) {
  footer {
    padding-top: 51px;
  }
}

.footer-login {
  .rodape {
    * {
      color: $cinza-medio;
    }
    .container {
      display: flex;
      justify-content: space-between;
    }
    .txtsm {
      margin-bottom: 0;
    }

    .dev {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      img {
        margin-left: 14px;
      }
    }
  }

  @media (max-width: 768px) {
    justify-content: center;
    align-items: center;

    .rodape {
      padding-bottom: 0;
      .container {
        justify-content: center;
      }
      .dev {
        display: none;
      }
    }
  }
}

.txtsm {
  font-weight: normal;
  font-size: 0.875rem;
  line-height: 150%;
  letter-spacing: 0.01em;
}
</style>
<script>
import axios from "axios";
import RegistrationScreenBanner from "@/components/RegistrationScreenBanner";
import RegistrationScreenForm from "@/components/RegistrationScreenForm";
import FooterNewLogin from "@/components/FooterNewLogin";

export default {
  data() {
    return {
      menuOpened: false,
      newUser: {},
    };
  },
  components: {
    RegistrationScreenBanner,
    RegistrationScreenForm,
    FooterNewLogin,
  },
  methods: {
    //tagueamento GA
    taggingGA() {
      this.$ga.page({
        page: '/criar-conta',
        title: 'CriarConta',
      })
    },

    async createNewAccountInRepository(value) {
      this.newUser = value;

      const { fullname: Name, password: Password, email: Email } = this.newUser;

      try {
        const response = await axios.post(process.env.API_GO_URL + '/new_sign_up', {Name, Password, Email})
        const token = response.data

        this.$store.dispatch('login', {email: Email, password: Password, keepLogged: true});
        this.$ga.event('NewUser', 'start', 'Investidor')

        const currentUser = response.data.user;

        const now = new Date();

        mixpanel.people.set({
          'USER_ID': currentUser.id,
          'sign_up_date': now,
          'email': Email,
          'name': Name,
          'Tipo': 'Investidor',
        });

        mixpanel.identify(currentUser.id);

        mixpanel.track("CREATE_ACCOUNT", {
          timestamp: now
        });

        console.log('mix ', mixpanel);

        this.$Notify.info('Conta criada com sucesso!');

        this.$router.push("/cadastro-concluido-com-sucesso");        
      } catch (error) {
         if(error.response.data.Msg){
            this.$Notify.error(error.response.data.Msg);
          }else{
            this.$Notify.error("Tivemos um erro inesperado, tente novamente mais tarde");
          }
      }
    },
  },
  created() {
    //tagueamento GA
    this.taggingGA();
  }
};
</script>



// WEBPACK FOOTER //
// src/views/NovoCadastroUsuario.vue